export const ADMIN_ACCESS_TOKEN = 'adminAccessToken'
